import React from 'react'

export const Tooltip: React.FC<
  React.PropsWithChildren<{
    text: string
    className?: string
  }>
> = ({ children, text, className }) => {
  return (
    <div className="flex flex-row items-center relative group">
      {children}
      <div className={`${className ? className : 'tooltip'}`}>{text}</div>
    </div>
  )
}
